import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { statusToColors, statusToIcon } from './utils';
import { Portal } from '../../Elements/Portal';
import { Icon } from '../../Elements/Icon';
import { Container, Header, Status, StatusText, Wrapper, CloseBtn } from './styles';
export var CornerDialog = function (_a) {
    var title = _a.title, children = _a.children, onClose = _a.onClose, statusToTitle = _a.statusToTitle, _b = _a.isOpen, isOpen = _b === void 0 ? true : _b, _intent = _a.intent;
    var _c = useState(false), isMounted = _c[0], setIsMounted = _c[1];
    useEffect(function () {
        setIsMounted(true);
    }, []);
    var intent = _intent !== null && _intent !== void 0 ? _intent : 'info';
    var _d = statusToColors[intent], fontColor = _d.fontColor, backgroundColor = _d.backgroundColor, fill = _d.fill;
    if (!isOpen)
        return null;
    return (_jsx(Portal, { children: _jsxs(Container, { "$mounted": isMounted, children: [_jsxs(Status, { background: backgroundColor, children: [_jsx(Icon, { icon: statusToIcon[intent], fill: fill }), _jsx(StatusText, { fontColor: fontColor, children: statusToTitle[intent]() })] }), _jsx(Header, { children: title }), _jsx(CloseBtn, { onClick: onClose, children: _jsx(Icon, { icon: "close", size: "25px" }) }), _jsx(Wrapper, { children: children })] }) }));
};
